var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bookStatistics"},[_c('div',{staticClass:"title"},[_vm._v("知识图谱")]),_c('div',{staticClass:"chartView"},[_c('div',{staticClass:"box-chart",attrs:{"id":"knowledgeMap"}})])])
}]

export { render, staticRenderFns }